import React, { useRef, useState } from "react";
import axios from "axios";
import { useReactToPrint } from "react-to-print";
import ReactModal from "react-modal";
import Cookies from "universal-cookie";
import CreaComentarios from "./CreaComentarios";

// Componente imprimible
// ✅ Componente correctamente conectado con forwardRe
// eslint-disable-next-line react/prop-types
const PrintableContrato = React.forwardRef(({ html }, ref) => {
  return <div ref={ref} dangerouslySetInnerHTML={{ __html: html }} />;
});

const Pruebas = (props) => {
  const cookie = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [isHtmlLoaded, setIsHtmlLoaded] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const componentRef = useRef();

  const handleOpenModalTest = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setIsHtmlLoaded(false);
    setIsExpanded(false);
  };

  const fetchHtmlContent = async () => {
    try {
      const response = await axios.get(
        // eslint-disable-next-line react/prop-types
        `https://contratosback.azurewebsites.net/api/v1/ObtenerContrato/${props.id}`
      );
      setHtmlContent(response.data);
      setIsHtmlLoaded(true);
    } catch (error) {
      console.error("Error fetching HTML content", error);
    }
  };

  // ✅ Imprimir directamente en impresora del sistema
  const handlePrint = () => {
    if (!htmlContent) {
      alert("El contenido aún no está cargado.");
      return;
    }

    const newTab = window.open("", "_blank");
    newTab.document.open();
    newTab.document.write(`
    <html>
      <head>
        <title>Contrato ${props.id}</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }
        </style>
      </head>
      <body>
        ${htmlContent}
        <br/>
        <button onclick="window.print()" style="
          padding: 10px 20px;
          margin-top: 20px;
          background: #dc3545;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
        ">Imprimir</button>
      </body>
    </html>
  `);
    newTab.document.close();
  };

  return (
    <div>
      <br />
      <button
        className="btn btn-primary btn-lg"
        onClick={handleOpenModalTest}
        style={{ padding: "10px 10px", fontSize: "13px" }}
      >
        Visualizar contrato
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Previsualización del Contrato"
        style={{
          overlay: { zIndex: 2000 },
          content: {
            top: "5%",
            left: "5%",
            right: "5%",
            bottom: "5%",
            padding: "20px",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {/* Botón Cerrar */}
        <button
          onClick={closeModal}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "#a4a5a5",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            fontSize: "14px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 3000,
          }}
        >
          ×
        </button>

        <br />
        {/* Botones de acción */}
        <div className="mb-3 d-flex gap-2">
          <button className="btn btn-primary btn-sm" onClick={fetchHtmlContent}>
            Previsualizar el documento
          </button>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => setIsExpanded(!isExpanded)}
            disabled={!isHtmlLoaded}
          >
            {isExpanded ? "Contraer vista" : "Expandir vista"}
          </button>
        </div>

        {/* Contenido dividido */}
        <div
          style={{
            display: "flex",
            flexDirection: isExpanded ? "column" : "row",
            flex: 1,
            gap: "15px",
            overflow: "hidden",
          }}
        >
          {/* Vista del contrato */}
          <div
            style={{
              flex: isExpanded ? "none" : 7,
              overflowY: "auto",
              border: "1px solid #ccc",
              padding: "10px",
              backgroundColor: "#fdfdfd",
              maxHeight: "70vh",
              height: isExpanded ? "85vh" : "auto",
              width: isExpanded ? "100%" : "auto",
            }}
          >
            {isHtmlLoaded ? (
              <PrintableContrato ref={componentRef} html={htmlContent} />
            ) : (
              <div className="text-muted">
                Si no puede visualizar el contenido, haga clic en el botón de Previsualización.
              </div>
            )}
          </div>

          {/* Comentarios */}
          {!isExpanded && (
            <div
              style={{
                flex: 3,
                overflowY: "auto",
                padding: "10px",
                backgroundColor: "#f8f9fa",
                border: "1px solid #ddd",
                maxHeight: "70vh",
              }}
            >
              <CreaComentarios
                // eslint-disable-next-line react/prop-types
                id={props.id}
              />
            </div>
          )}
        </div>

        {/* Botón para imprimir */}
        <button
          className="btn btn-danger btn-lg mt-3"
          onClick={() => {
            if (componentRef.current) {
              handlePrint();
            } else {
              alert("El contenido aún no está disponible para imprimir.");
            }
          }}
          disabled={!isHtmlLoaded}
        >
          Imprimir documento
        </button>
      </ReactModal>
    </div>
  );
};

export default Pruebas;
